<!--
 * @Author: Merlin
 * @Date: 2024-07-16 13:33:43
 * @LastEditors: Merlin
 * @LastEditTime: 2024-12-09 15:30:56
 * @Description: 
-->
<template>
    <div class="flex flex-col gap-3 pt-2 pb-3">
        <div class="flex flex-col gap-2">
            <div class="flex text-[#93acd3] font-medium">
                <span class="flex-1 h-7">
                    {{ t.MinBet }}
                </span>
                <span class="flex-1 h-7">
                    {{ t.MaxBet }}
                </span>
            </div>
            <!-- ↓2个下拉菜单 --> 
            <ModalRulesLimitComponentDropDown
                @click="() => (showNormalRules = !showNormalRules)"
                :class="panelPadding"
            />
            <ModalRulesLimitComponentDropDownList
                :show="showNormalRules"
                :class="[panelPadding]"
            />
        </div>
    </div>
</template>

<script lang="ts" >
export default defineComponent({name: 'LimitDialogBody'});
</script>


<script setup lang="ts">
import useTranslation from '~/i18n/useTransLation';
const showNormalRules = ref(true);

const t = useTranslation();

const panelPadding = 'px-[18px]';
</script>
